import { useState } from 'react';

import useAuth from './useAuth';

import { Button, Modal } from '@/components';

const useConfirmLogout = () => {
  const [confirmLogout, setConfirmLogout] = useState(false);
  const { logout } = useAuth();

  const showConfirmLogoutModal = () => {
    sessionStorage.removeItem('tkRed');
    setConfirmLogout(true);
  };
  const hideConfirmLogoutModal = () => setConfirmLogout(false);

  const handleLogout = () => {
    hideConfirmLogoutModal();
    logout();
  };

  const renderExitModal = () => (
    <Modal
      closeOutside={false}
      controlledOnClose={hideConfirmLogoutModal}
      isControlledOpen={Boolean(confirmLogout)}
      render={() => (
        <div className="space-y-10 mb-6">
          <h1 className="text-base text-gdt-gray font-semibold text-center">
            ¿Estás seguro de que querés <br /> cerrar sesión?
          </h1>
          <div className="flex space-x-4">
            <Button
              className="flex-1"
              type="button"
              variant="secondary"
              onClick={hideConfirmLogoutModal}
            >
              Cancelar
            </Button>
            <Button
              className="flex-1 space-x-2"
              type="button"
              variant="primary"
              onClick={handleLogout}
            >
              <span>Cerrar sesión</span>
            </Button>
          </div>
        </div>
      )}
      showCloseButton={false}
      size="xs"
      variant="controlled"
    />
  );

  return { renderExitModal, showConfirmLogoutModal };
};

export default useConfirmLogout;
